import React from 'react';
import { Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import styles from './CygnusField.module.css';
import { CygnusFieldProps } from './CygnusField.utils';

/**
 * CygnusField Component
 *
 * Renders an individual field item with a label, icon, and add/remove toggle.
 * This component is used in MDM field selection UIs.
 */
const CygnusField: React.FC<CygnusFieldProps> = ({ field, onRemoveField, onAddField }) => {
  const handleRemove = () => {
    if (onRemoveField) onRemoveField(field);
  };

  const handleAdd = () => {
    if (onAddField) onAddField(field);
  };

  return (
    <div className={styles.container}>
      <div className={styles.dragIcon}>
        <Image
          src={field.sourceimg ? field.sourceimg : require("../../../../../images/undefined.png")}
          className={styles.fieldIcon}
        />
      </div>

      <OverlayTrigger
        placement="bottom"
        delay={{ show: 500, hide: 100 }}
        overlay={
          <Tooltip id={`tooltip-${field.field_code}`}>
            This field belongs to {field.category} category
          </Tooltip>
        }
      >
        <p className={styles.fieldLabel}>{field.field_name}</p>
      </OverlayTrigger>

      {field.selected ? (
        <Icon.DashCircleFill className={styles.actionIcon} onClick={handleRemove} />
      ) : (
        <Icon.PlusCircleFill className={styles.actionIcon} onClick={handleAdd} />
      )}
    </div>
  );
};

export default CygnusField;
